import Vue from 'vue'
import router from '../../router'

const state = () => {
  return {
    selected: {},
    likes: [],
    list: [],
    filters: null
  }
}

const getters = {
  selected: (state) => {
    let feature = state.list.find((feature) => feature.slug === state.selected)
    return feature
  }
}

const mutations = {
  SELECT_FEATURE(state, feature) {
    //let index = state.list.findIndex(board => board.slug === slug)
    state.selected = feature
  },
  SET_FEATURES(state, features) {
    state.list = [...features]
  },
  SET_LIKES(state, likes) {
    state.likes = [...likes]
  },
  SET_FILTERS(state, filters) {
    state.filters = filters
  },
  ADD_FEATURE(state, feature) {
    if (state.list.findIndex((f) => f.slug === feature.slug) === -1) {
      state.list.unshift(feature)
    }
  },

  ADD_FEATURE_LIKE(state, { slug, user, data }) {
    if (state.selected._id && state.selected.slug === slug && !state.selected.isLiked) {
      state.selected.isLiked = true
      state.selected.stats.likes++
      state.selected.isWatched = true
    }
    const featureIndex = state.list.findIndex((feature) => feature.slug === slug)
    if (featureIndex > -1 && !state.list[featureIndex].isLiked) {
      state.list[featureIndex].isLiked = true
      state.list[featureIndex].stats.likes++
    }

    user.fullName = `${user.firstName} ${user.lastName}`

    if (state.likes.findIndex((l) => l._id === data._id) === -1) {
    state.likes.push({
        _id: data._id,
        user,
        created: data.created
    })
    }
  },

  UNMERGE_FEATURE(state) {
    state.selected.isReadOnly = false
  },
  DELETE_FEATURE_LIKE(state, { slug, user }) {
    let featureIndex = state.list.findIndex((feature) => feature.slug === slug)
    if (state.selected._id && state.selected.slug === slug && state.selected.isLiked) {
      state.selected.isLiked = false
      state.selected.stats.likes--
      state.selected.isWatched = false
    }
    if (featureIndex > -1 && state.list[featureIndex].isLiked) {
      state.list[featureIndex].isLiked = false
      state.list[featureIndex].stats.likes--
    }
    let likeIndex = state.likes.findIndex((like) => like.user._id === user._id)
    if (likeIndex > -1) {
      state.likes.splice(likeIndex, 1)
    }
  },

  ADD_FEATURE_WATCH(state, slug) {
    state.selected.isWatched = true
  },

  DELETE_FEATURE_WATCH(state, slug) {
    state.selected.isWatched = false
  },

  UPDATE_FEATURE(state, feature) {
    const { slug } = feature
    const featureIndex = state.list.findIndex((f) => f.slug === slug)
    if (featureIndex > -1) {
    state.list[featureIndex] = feature
    }
    if (state.selected._id && state.selected.slug === slug) {
      state.selected = feature
    }
  },

  UPDATE_STATUS(state, status) {
    state.selected.status = status
  },

  DELETE_FEATURE(state, slug) {
    let featureIndex = state.list.findIndex((feature) => feature.slug === slug)
    state.list.splice(featureIndex, 1)

    if (state.selected._id && state.selected.slug === slug) {
    state.selected = { stats: {}, creator: {} }
  }
}
}

const actions = {
  async getFeatures({ rootState, commit }) {
    try {
      const slug = rootState.boards.selected
      let { data } = await Vue.axios.get(`board/${slug}/features`)
      commit('SET_FEATURES', data)
    } catch (error) {}
  },
  async getFeature({ state, commit }, slug) {
    try {
      let { data } = await Vue.axios.get(`feature/${slug}`)
      commit('SELECT_FEATURE', data)

      return data
    } catch (error) {
      //console.log(error)
      throw error.response.data.error
    }
  },
  async getLikes({ state, commit }, slug) {
    try {
      let { data } = await Vue.axios.get(`feature/${slug}/likes`)
      commit('SET_LIKES', data)
    } catch (error) {
      console.log(error)
    }
  },
  async postFeature({ rootState, commit, dispatch }, feature) {
    try {
      const slug = rootState.boards.selected
      let { data } = await Vue.axios.post(`board/${slug}/features`, feature)
      commit('ADD_FEATURE', data)
      dispatch('boards/getBoards', null, { root: true })
      //return
    } catch (error) {
      throw error.response.data.error
    }
  },

  async receiveNewFeature({ commit }, feature) {
    commit('ADD_FEATURE', feature)
  },

  async voteFeature({ commit, rootState }, slug) {
      let user = rootState.user
      let { data } = await Vue.axios.put(`feature/${slug}/action/like`)
    commit('ADD_FEATURE_LIKE', { slug, user, data })
  },

  async receivedVoteFeature({ commit }, data) {
    const {
      feature: { slug },
      user,
      featureLike
    } = data
    commit('ADD_FEATURE_LIKE', { slug, user, data: featureLike })
  },
  async unvoteFeature({ commit, rootState }, slug) {
      let user = rootState.user
    await Vue.axios.delete(`feature/${slug}/action/like`)
    commit('DELETE_FEATURE_LIKE', { slug, user })
  },
  async receivedUnvoteFeature({ commit }, data) {
    const {
      feature: { slug },
      user
    } = data

    commit('DELETE_FEATURE_LIKE', { slug, user })
  },

  async watchFeature({ commit }, slug) {
    try {
      await Vue.axios.put(`feature/${slug}/action/watch`)
      commit('ADD_FEATURE_WATCH', slug)
    } catch (error) {
      throw error.response.data.error
    }
  },
  async unwatchFeature({ commit }, slug) {
    try {
      await Vue.axios.delete(`feature/${slug}/action/watch`)
      commit('DELETE_FEATURE_WATCH', slug)
    } catch (error) {
      console.log(error)
    }
  },
  async updateStatus({ commit }, { slug, status }) {
    try {
      let { data } = await Vue.axios.put(`feature/${slug}/action/status`, status)
      commit('UPDATE_STATUS', data.status)
      return data
    } catch (error) {
      return false
    }
  },
  async updateAssign({ commit }, { slug, assign }) {
    try {
      let { data } = await Vue.axios.put(`feature/${slug}/action/assign`, assign)
      return data
    } catch (error) {}
  },
  async updateUnassign({ commit }, { slug, assign }) {
    try {
      let { data } = await Vue.axios.delete(`feature/${slug}/action/assign`, {
        data: assign
      })
      return data
    } catch (error) {}
  },
  async updateBoard({ commit, dispatch }, { slug, update }) {
    try {
      await Vue.axios.put(`feature/${slug}/action/move`, update)
      dispatch('boards/getBoards', null, { root: true })
    } catch (error) {}
  },

  async updateBoardReceived({ rootState }, { feature, board }) {
    console.log('here we is')
    if (rootState.features.selected.slug === feature.slug) {
      console.log('dialog box prompt')
      Vue.prototype.$DialogBox.open({
        parent: null,
        open: true,
        header: 'Whoops!',
        message: 'The feature you are looking at was moved to another board. Click Ok to reload feature',
        onConfirm: () => {
          router.replace({ name: 'PublicFeature', params: { boardSlug: board.slug, featureSlug: feature.slug } })
        }
      })
    }
  },

  async updateFeature({ commit }, { slug, update }) {
    let { data } = await Vue.axios.put(`feature/${slug}`, update)
    commit('UPDATE_FEATURE', data)
  },

  async receiveUpdateFeature({ commit }, feature) {
    commit('UPDATE_FEATURE', feature)
  },

  async searchFeatures({ commit }, { filter, sort }) {
    try {
      let { data } = await Vue.axios.post(`feature/search`, { filter, sort })
      commit('SET_FEATURES', data)
    } catch (error) {}
  },

  async mergeFeature({ commit }, { slug, update }) {
    try {
      await Vue.axios.put(`feature/${slug}/action/link`, update)
      // console.log('ETTING BOARDS')
      dispatch('boards/getBoards', null, { root: true })
      return
    } catch (error) {}
  },

  async mergeFeatureReceived({ commit, rootState }, event) {
    const { feature, link, activity, linkedActivity, user } = event
    const { features } = rootState

    if (features.selected.slug === feature.slug) {
      commit('UPDATE_FEATURE', feature)
      commit('activities/ADD_ACTIVITY', { ...activity, user, linkedFeature: link }, { root: true })
    }

    if (features.selected.slug === link.slug) {
      commit('activities/ADD_ACTIVITY', { ...linkedActivity, user, linkedFeature: feature }, { root: true })
    }
  },

  async unmergeFeature({ commit }, { slug, update }) {
    try {
      let { data } = await Vue.axios.delete(`feature/${slug}/action/link`, { data: update })
      commit('UNMERGE_FEATURE')
      dispatch('boards/getBoards', null, { root: true })
      /* //TODO: this does not have the data it needs to perform this. */
      //commit('activities/ADD_ACTIVITY', { data }, { root: true })
    } catch (error) {}
  },

  async unmergeFeatureReceived({ commit, rootState }, event) {
    const { feature, link, activity, linkedActivity, user } = event
    const { features } = rootState

    if (features.selected.slug === feature.slug) {
      commit('UPDATE_FEATURE', feature)
      commit('activities/ADD_ACTIVITY', { ...activity, user, linkedFeatureWas: link }, { root: true })
    }

    if (features.selected.slug === link.slug) {
      commit('activities/ADD_ACTIVITY', { ...linkedActivity, user, linkedFeatureWas: feature }, { root: true })
    }
  },

  async deleteFeature({ commit, dispatch }, slug) {
    try {
      let { data } = await Vue.axios.delete(`feature/${slug}`)
      dispatch('boards/getBoards', null, { root: true })
      commit('DELETE_FEATURE', slug)
    } catch (error) {}
  },

  async receiveDeletedFeature({ commit, dispatch }, feature) {
    dispatch('boards/getBoards', null, { root: true })
    commit('DELETE_FEATURE', feature.slug)
  },

  async importFeatures({ commit, rootGetters, dispatch }, form) {
    try {
      let board = rootGetters['boards/selected']
      form.board = board._id
      let { data } = await Vue.axios.post(`company/import`, form)
      dispatch('boards/getBoards', null, { root: true })
    } catch (error) {
      console.log('importFeatures', error)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
